import { ListCustomizer } from '@kinet-open-network/client/core/forms/ui';
import { Delivery } from '@kinet-open-network/client/deliveries/data-access';
import { DeliveriesListComponent } from '@kinet-open-network/client/deliveries/feature/list';

export const deliveriesListCustomization: ListCustomizer<
  Delivery,
  DeliveriesListComponent
> = () => ({
  columns: [
    {
      key: 'carLicensePlate',
      label: 'ŠPZ auta',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'trailerLicensePlate',
      label: 'ŠPZ prívesu',
      filter: 'text',
      hidden: true,
    },
    {
      key: 'driverName',
      label: 'Meno vodiča',
      filter: 'text',
      hidden: true,
    },
  ],
});
